import { Injectable } from '@angular/core';
import { Procedure } from '../../models/Procedure';

@Injectable({
  providedIn: 'root'
})
export class ProcedureService {

  constructor() { }

  getProcedure(controls): Procedure {
    const procedure = new Procedure();

    procedure.concoursRestreint = controls.get('_SepSep_Rectificatif_SepSep_Procedure_SepAtt_concoursRestreint')
    procedure.procedureAdaptee = controls.get('_SepSep_Rectificatif_SepSep_Procedure_SepAtt_procedureAdaptee')
    procedure.appelRestreint = controls.get('_SepSep_Rectificatif_SepSep_Procedure_SepAtt_appelRestreint')
    procedure.appelOuvert = controls.get('_SepSep_Rectificatif_SepSep_Procedure_SepAtt_appelOuvert')
    procedure.concoursOuvert = controls.get('_SepSep_Rectificatif_SepSep_Procedure_SepAtt_concoursOuvert')
    procedure.autres = controls.get('_SepSep_Rectificatif_SepSep_Procedure_SepAtt_autres')
    procedure.dialogueCompetitif = controls.get('_SepSep_Rectificatif_SepSep_Procedure_SepAtt_dialogueCompetitif')
    procedure.marcheNegocie = controls.get('_SepSep_Rectificatif_SepSep_Procedure_SepAtt_marcheNegocie')

    return procedure;
  }
}
